<template>
    <form
        @submit.prevent="requestCreate()"
    >
        <div class="row" v-if="meetingRooms.length == 1">
            <div
                class="col-12"
            >
                <b-form-group
                    :label="$t('module.meetingRoom')"
                    label-cols="3"
                    label-align="left"
                >
                    <b-form-input
                        :value="meetingRooms[0].name"
                        class="border border-0 bg-light"
                        disabled
                    />
                </b-form-group>
            </div>
        </div>
        <div v-if="meetingRooms.length == 0" class="row">
            <div class="col-12">
                <b-form-group
                    :label="$t('module.meetingRoom')"
                    label-cols="3"
                    label-align="left"
                >
                    <multiselect
                        v-model="selectedMeetingRooms"
                        :options="meetingRoomDdl"
                        :multiple="true"
                        :close-on-select="false"
                        track-by="value"
                        label="text"
                        :placeholder="$t('message.pleaseSelectX', [$t('module.meetingRoom')])"
                        @input="searchListing"
                        :class="[submitted && !$v.meetingRoomUuids.required ? 'border-danger' : 'border-transparent', 'border']"
                    />
                    <div v-if="submitted && !$v.meetingRoomUuids.required" class="invalid-feedback d-block text-right">
                        {{ $t('message.requiredX', [$t('module.meetingRoom')]) }}
                    </div>
                </b-form-group>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-6">
                <b-form-group
                    :label="$t('label.date')"
                    label-cols="3"
                    label-align="left"
                >
                    <date-picker
                        v-model="createForm.date"
                        type="date"
                        format="YYYY-MM-DD"
                        value-type="format"
                        :editable="false"
                        :clearable="false"
                    />
                </b-form-group>
                <b-form-group
                    :label="$t('label.agenda')"
                    label-cols="3"
                    label-align="left"
                >
                    <b-form-input
                        v-model="createForm.agenda"
                        :class="{ 'is-invalid': submitted && !$v.createForm.agenda.required }"
                        autocomplete="off"
                    />
                    <b-form-invalid-feedback v-if="submitted && !$v.createForm.agenda.required" class="d-flex align-items-center justify-content-end">
                        {{ $t("message.requiredX", [$t("label.agenda")]) }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                    :label="$t('label.detail')"
                    label-cols="3"
                    label-align="left"
                >
                    <b-form-textarea
                        rows="3"
                        autocomplete="off"
                        v-model="createForm.detail"
                    />
                </b-form-group>
            </div>
        </div>
        <hr class="mt-0 mx-n3" />
        <div class="row" v-if="listStatus">
            <div class="col-md-6">
                <div
                    v-for="(slot, index) in leftSlots"
                    :key="index"
                    class="d-flex align-items-center mb-2"
                >
                    <div class="text-right mr-3" style="width: 70px;">
                        <small>{{ slot.label }}</small>
                    </div>
                    <div
                        :id="'left-popover-' + index"
                        class="flex-grow-1 border rounded text-center py-1 cursor-pointer"
                        :class="{
                            'bg-danger text-white border-danger': slot.booked,
                            'bg-info text-white border-info': selectedSlots.includes(slot.value),
                            'bg-white text-muted': !slot.booked && !selectedSlots.includes(slot.value),
                            'border-danger': submitted && !$v.selectedSlots.required
                        }"
                        @click="selectTimeSlot(slot)"
                    >
                        {{ slot.booked ? $t('label.reserved') : $t('label.selectX', []) }}
                    </div>
                    <b-popover
                        v-if="slot.booked"
                        :target="'left-popover-' + index"
                        triggers="hover focus"
                        placement="right"
                        container="body"
                        custom-class="border border-secondary shadow-lg ml-3 meeting-popover"
                    >
                        <div>
                            <div class="font-weight-bolder text-info font-size-14">
                                <i class="mdi mdi-calendar-check mr-1"></i>
                                {{ $t('label.reserved') }}
                            </div>
                            <hr class="my-1 mx-n2 border-info" />
                            <div class="meeting-popover-bookings">
                                <div
                                    v-for="(booking, bookingIndex) in slot.bookings"
                                    :key="booking.uuid || bookingIndex"
                                    class="meeting-popover-booking"
                                >
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted">Meeting Room</small><br>
                                    {{ booking.meetingRoom?.name || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Date</small><br>
                                    {{ booking.date }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Time</small><br>
                                    {{ booking.start }} - {{ booking.end }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Booked By</small><br>
                                    {{ booking.createdByUser?.firstName }} {{ booking.createdByUser?.lastName }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Phone</small><br>
                                    {{ booking.createdByUser?.phone || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Email</small><br>
                                    {{ booking.createdByUser?.email || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Agenda</small><br>
                                    {{ booking.agenda || '-' }}
                                </div>
                                <div>
                                    <small class="text-muted font-weight-bold">Details</small><br>
                                    {{ booking.description || '-' }}
                                </div>
                                    <hr
                                        v-if="bookingIndex < slot.bookings.length - 1"
                                        class="my-2 mx-n4 border-secondary"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-popover>
                </div>
            </div>
            <div class="col-md-6">
                <div
                    v-for="(slot, index) in rightSlots"
                    :key="index"
                    class="d-flex align-items-center mb-2"
                >
                    <div class="text-right mr-3" style="width: 70px;">
                        <small>{{ slot.label }}</small>
                    </div>
                    <div
                        :id="'right-popover-' + index"
                        class="flex-grow-1 border rounded text-center py-1 cursor-pointer"
                        :class="{
                            'bg-danger text-white border-danger': slot.booked,
                            'bg-info text-white border-info': selectedSlots.includes(slot.value),
                            'bg-white text-muted': !slot.booked && !selectedSlots.includes(slot.value),
                            'border-danger': submitted && !$v.selectedSlots.required
                        }"
                        @click="selectTimeSlot(slot)"
                    >
                        {{ slot.booked ? $t('label.reserved') : $t('label.selectX', []) }}
                    </div>
                    <b-popover
                        v-if="slot.booked"
                        :target="'right-popover-' + index"
                        triggers="hover focus"
                        placement="right"
                        container="body"
                        custom-class="border border-secondary shadow-lg ml-3 meeting-popover"
                    >
                        <div>
                            <div class="font-weight-bolder text-info font-size-14">
                                <i class="mdi mdi-calendar-check mr-1"></i>
                                {{ $t('label.reserved') }}
                            </div>
                            <hr class="my-1 mx-n3" />
                            <div class="meeting-popover-bookings">
                                <div
                                    v-for="(booking, bookingIndex) in slot.bookings"
                                    :key="booking.uuid || bookingIndex"
                                    class="meeting-popover-booking"
                                >
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted">Meeting Room</small><br>
                                    {{ booking.meetingRoom?.name || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Date</small><br>
                                    {{ booking.date }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Time</small><br>
                                    {{ booking.start }} - {{ booking.end }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Booked By</small><br>
                                    {{ booking.createdByUser?.firstName }} {{ booking.createdByUser?.lastName }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Phone</small><br>
                                    {{ booking.createdByUser?.phone || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Email</small><br>
                                    {{ booking.createdByUser?.email || '-' }}
                                </div>
                                <div class="mb-1 font-weight-bolder">
                                    <small class="text-muted font-weight-bold">Agenda</small><br>
                                    {{ booking.agenda || '-' }}
                                </div>
                                <div>
                                    <small class="text-muted font-weight-bold">Details</small><br>
                                    {{ booking.description || '-' }}
                                </div>
                                    <hr
                                        v-if="bookingIndex < slot.bookings.length - 1"
                                        class="my-2 mx-n3"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-popover>
                </div>
            </div>
            <div class="col-12">
                <div v-if="submitted && !$v.selectedSlots.required" class="invalid-feedback d-flex align-items-center justify-content-end">
                    {{ $t("message.requiredX", [$t("label.timeSlot")]) }}
                </div>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
            <div class="p-5 m-5">
                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="col-md-2 mb-1 mr-2"
                :disabled="!status.save"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-md-2 mb-1"
                :disabled="!status.save"
            >
                <span v-if="status.save">{{ $t('label.submit') }}</span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
</template>
<script>
import Multiselect from "vue-multiselect";
import { meetingRoomBookingModel } from "@/models/app/meetingRoomBooking.model";
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapState } from "vuex";
import { meetingRoomBookingMethods, lookupMethods } from "@/state/app";
import { MEETING_ROOM_BOOKING_MODULE } from "@/state/app/meetingRoomBooking.state";

export default {
    props: {
        meetingRooms: {
            type: Array,
            default: () => [],
        },
    },
    components: { DatePicker, Multiselect },
    validations() {
        return {
            createForm: {
                agenda: { required },
            },
            selectedSlots: { required },
            meetingRoomUuids: { required },
        };
    },
    created() {
        if (this.meetingRooms.length == 0) this.lookupMeetingRoom();
        this.searchListing();
    },
    watch: {
        'createForm.date'() {
            this.searchListing();
        },
    },
    data() {
        return {
            createForm: {
                agenda: "",
                detail: "",
                date: moment().format('YYYY-MM-DD'),
            },
            selectedSlots: [],
            selectedMeetingRooms: [],
            localTableRows: [],
            requestNumber: 0,
            submitted: false,
            listStatus: false,
            occupiedLoaded: false,
        };
    },
    methods: {
        ...meetingRoomBookingMethods,
        ...lookupMethods,
        searchListing() {
            this.selectedSlots = [];
            this.occupiedLoaded = false;
            this.localTableRows = [];
            const requestNumber = ++this.requestNumber;
            if (this.meetingRoomUuids.length == 0) {
                this.listStatus = true;
                return;
            }
            this.listStatus = false;
            let filter = {
                meetingRoomUuids: [...this.meetingRoomUuids],
                meetingDateStart: this.createForm.date,
            };
            this.showAllMeetingRoomBooking({filter})
                .then((result) => {
                    if (requestNumber != this.requestNumber) return;
                    this.localTableRows = result?.success ? (result.data || []).map(item => meetingRoomBookingModel(item)) : [];
                    this.occupiedLoaded = !!result?.success;
                    this.listStatus = true;
                });
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid || !this.listStatus || !this.occupiedLoaded || !this.status.save) {
                return;
            } else {
                if (this.timeSlots.some(item => item.booked && this.selectedSlots.includes(item.value))) {
                    this.selectedSlots = [];
                    return;
                }
                let data = {
                    meetingRoomUuids: [...this.meetingRoomUuids],
                    agenda: this.createForm.agenda,
                    detail: this.createForm.detail,
                    start: this.createForm.date + ' ' + this.selectedSlots[0],
                    end: moment(this.createForm.date + ' ' + this.selectedSlots[this.selectedSlots.length - 1], 'YYYY-MM-DD HH:mm').add(30, 'minutes').format('YYYY-MM-DD HH:mm'),
                };
                this.createMeetingRoomBooking({data})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.$emit('saved');
                            this.$emit('done');
                        }
                    }));
            }
        },
        formatTime(hour, minute) {
            return moment({hour, minute}).format('h:mm A');
        },
        selectTimeSlot(slot) {
            if (slot.booked || (this.meetingRoomUuids.length > 0 && !this.occupiedLoaded) || !this.status.save) return;
            if (this.selectedSlots.length == 0) {
                this.selectedSlots = [slot.value];
                return;
            }
            if (slot.value == this.selectedSlots[this.selectedSlots.length - 1]) {
                this.selectedSlots.pop();
                return;
            }
            if (slot.value == this.selectedSlots[0]) {
                this.selectedSlots.shift();
                return;
            }
            const firstIndex = this.timeSlots.findIndex(item => item.value == this.selectedSlots[0]);
            const currentIndex = this.timeSlots.findIndex(item => item.value == slot.value);
            const selectedRange = this.timeSlots.slice(Math.min(firstIndex, currentIndex), Math.max(firstIndex, currentIndex) + 1);
            if (selectedRange.some(item => item.booked)) return;
            this.selectedSlots = selectedRange.map(item => item.value);
        },
    },
    computed: {
        ...mapState(MEETING_ROOM_BOOKING_MODULE, ['status']),
        meetingRoomDdl() {
            return this.$store.state.app.lookup.meetingRoomDdl || [];
        },
        meetingRoomUuids() {
            return this.meetingRooms.length ? this.meetingRooms.map(item => item.uuid) : this.selectedMeetingRooms.map(item => item.value);
        },
        tableRows() {
            return this.occupiedLoaded ? this.localTableRows : [];
        },
        timeSlots() {
            const slots = [];
            for (let minutes = 8 * 60; minutes < 20 * 60; minutes += 30) { // start from 8, end at 20
                const hour = Math.floor(minutes / 60);
                const minute = minutes % 60;
                const value = String(hour).padStart(2, '0') + ':' + String(minute).padStart(2, '0');
                const start = moment(this.createForm.date + ' ' + value, 'YYYY-MM-DD HH:mm');
                const end = start.clone().add(30, 'minutes');
                const bookings = this.tableRows.filter(item => start.isBefore(moment(item.endAt)) && end.isAfter(moment(item.startAt)));
                slots.push({
                    value,
                    label: this.formatTime(hour, minute),
                    booked: bookings.length > 0,
                    bookings,
                });
            }
            return slots;
        },
        leftSlots() {
            return this.timeSlots.slice(0, this.timeSlots.length / 2);
        },
        rightSlots() {
            return this.timeSlots.slice(this.timeSlots.length / 2);
        },
    },
};
</script>
<style>
.meeting-room-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1050;
    max-height: 280px;
    overflow-y: auto;
}

.meeting-room-option-image {
    width: 40px;
    height: 40px;
    object-fit: cover;
    flex: 0 0 40px;
}

.meeting-room-selected-image {
    width: 48px;
    height: 48px;
    object-fit: cover;
    flex: 0 0 48px;
}

.meeting-popover.bs-popover-right .arrow::before {
    border-width: 8px 8px 8px 0;
    border-right-color: #6c757d !important;
}

.meeting-popover.bs-popover-right .arrow::after {
    border-width: 8px 8px 8px 0;
    border-right-color: #f8f9fa !important;
}

.meeting-popover {
    max-width: 320px;
}

.meeting-popover-bookings {
    max-height: 360px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 14px;
}

.meeting-popover-bookings::-webkit-scrollbar {
    width: 6px;
}

.meeting-popover-bookings::-webkit-scrollbar-track {
    background: #f1f3f5;
    border-radius: 4px;
}

.meeting-popover-bookings::-webkit-scrollbar-thumb {
    background: #6c757d;
    border-radius: 4px;
}
</style>
